module.exports = __webpack_public_path__ + "static/img/icon5-10.daa3668c.png";